var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._b({nativeOn:{"click":function($event){return _vm.$root.app.closeSidebar.apply(null, arguments)}}},'router-link',{ exact: _vm.exact, to: _vm.to || { name: _vm.name } },false),[_c('icon',_vm._b({staticClass:"mr-1"},'icon',{ icon: _vm.icon, iconType: _vm.iconType },false)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }